import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";
import Stack from "@mui/joy/Stack";
import Box from "@mui/joy/Box";
import Drawer from "@mui/joy/Drawer";
import IconButton from "@mui/joy/IconButton";
import Tooltip from "@mui/joy/Tooltip";
import Typography from "@mui/joy/Typography";



import UserPresenceIndicator from "components/UserPresenceIndicator";
import Sidebar from "components/Sidebar";


import useSidebar from "hooks/useSidebar";
import useRoles from "hooks/useRoles";
import useUserIdentity from "hooks/useUserIdentity";
// import useClock from 'hooks/useClock';

import getIcon from "utils/getIcon";

import Link from "components/Link";
import { SmallLogo }  from 'components/CombinedLogo';
import FancyHandsLogo from 'components/FancyHandsLogo';

import ClockHeader from 'components/ClockHeader';
import ProjectHeader from 'components/ProjectHeader';
import IdentityAvatar from 'components/IdentityAvatar';
import { FLogo } from "components/FancyHandsLogo";
import { ColorPaletteProp } from '@mui/joy';
import { PROJECT_HEADER_FONT_SIZE } from "components/ListicleProject";
import { LoreDecorator } from "components/Lore";


import ChatTopper from "./ChatTopper";
import FancyIcon from "./FancyIcon";

const TopperTitle = ({ title, icon, url, color, tooltip=undefined, loreSlug='' }: { title: string|React.ReactNode, icon: string, url: string, color?: undefined | ColorPaletteProp, tooltip?: string | undefined, loreSlug?: string}) => {
    const Icon = getIcon(icon);
    return (
        <Stack direction="row" spacing={1.5} alignItems="center">
        <Link to={url}>
        <Tooltip arrow
            title={tooltip}>
                <Typography
            startDecorator={<Icon color={color} />}
            fontSize={PROJECT_HEADER_FONT_SIZE}
            level="title-lg">
                    {title}
                    </Typography>

                    </Tooltip>

                    </Link>
                    { loreSlug &&
                        <LoreDecorator slug={loreSlug} />
                    }

                    </Stack>

    );
};
const Topper = observer(() => {
    const location = useLocation();
    const { currentIdentity } = useUserIdentity();
    const { showingRegularSidebar } = useSidebar();
    const { hasRole } = useRoles();

    const logo_url = (import.meta.env.PROD ?
        "/f-logo-grad.svg" :
        "/f-logo-grad.DEV.svg");
    // const HamburgerIcon = getIcon('Menu');

    const BackIcon = getIcon('ArrowBack');

    // const { currentClock } = useClock();
    const { showingSidebar, setShowingSidebar } = useSidebar();
    const section = location.pathname.split('/').length ?
        location.pathname.split('/')[1] : null;

    const sectionKey = location.pathname.split('/').length ?
        location.pathname.split('/')[2] : null;

    const showBasicHeader = ( section !== null &&
        ['account', 'settings', 'support', 'requests', 'lore',
            'calendar', 'email', 'chat', 'phone', 'parcel',
            'open', 'dedicated', 'collabs', 'invites', 'assistant',
            'team', 'roadmap', 'performance', 'payroll', ''].includes(section));

    return (
        <>
            {/* The Drawer that opens when you click the hamburger menu */}
            <Drawer
                anchor="left"
                size="sm"
                open={showingSidebar}
                onClose={() => setShowingSidebar && setShowingSidebar(false)} >

                <Stack direction="row"
                    padding={2}
                    alignItems="top"
                    justifyContent="flex-start"
                >

                    <IconButton
                        onClick={() => setShowingSidebar &&
                            setShowingSidebar(!showingSidebar)}>
                        <BackIcon />
                    </IconButton>


                <Stack >
                                { false && hasRole('trusted-tester') ?
                    <SmallLogo/> :
                    <FancyHandsLogo />}
                    </Stack>

                </Stack>
                <Sidebar />
            </Drawer>

            {/* The sidebar displays bar */}
            <Stack className="only-print" m={1} direction="row">
                <FLogo />
            </Stack>
            <Stack className="no-print" justifyContent="">
            <Stack
                justifyContent="flex-start"
                className="topper-fadeout"
                p={0}
                sx={{
                    position: "fixed",
                    zIndex: 999,
                    backgroundColor: `var(--BackgroundColor)`,
                    top: 0,
                    left: (showingRegularSidebar || showingSidebar) ? { xs: 0, md: `var(--SidebarWidth)` } : 5,
                    right: 0,
                    height: 'calc(var(--TopperHeight))',
                }}
            >
                <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1}
                        justifyContent="flex-start"
                     display={{ xs: 'flex', md: (showingRegularSidebar || showingSidebar)  ? 'none' : 'flex' }}>

                     {section != 'sidebar' &&
                         <Stack direction="row" spacing={1}>

                                        <Tooltip arrow
                                            title={"Show the sidebar"}
                                            placement="right"
                                        >
                                        <IconButton
                                             onClick={() => {setShowingSidebar && setShowingSidebar(!showingSidebar); return false;}}
                                                sx={{ pl: 2 }}
                                             className="clickable no-print">
                                             <FancyIcon name="Menu" />
                                            </IconButton>
                                        </Tooltip>


                                    <Link to={!showingRegularSidebar ? "/sidebar" : ''}>
                                        <Tooltip arrow
                                            title={!showingRegularSidebar ? "Show the sidebar" : 'Go Home'}
                                            placement="right"
                                        >
                                            <IconButton
                                                sx={{ pl: 2 }}
                                                className="clickable">
                                                <img
                                                    width="42"
                                                    src={logo_url} />
                                            </IconButton>
                                        </Tooltip>
                                    </Link>
                                </Stack>
                            }
                            {section == 'sidebar' &&
                                <>
                                    <Link to={"/"}>
                                        <IconButton
                                            sx={{ width: 56, ml: 1 }}
                                            className="clickable">
                                            <BackIcon />
                                        </IconButton>
                                    </Link>
                                    <FLogo />
                                </>
                            }

                    </Stack>


                    { showBasicHeader &&
                        <Stack
                            width="100%"
                        // alignItems="center"
                        // justifyContent="center"
                    >
                        {section == 'account' &&
                            <TopperTitle
                                title="Account"
                                url="/account"
                                icon="ContactPageOutlined" /> }
                        {section == 'open' &&
                            <TopperTitle
                                title="Open Tasks"
                                url="/open"
                                icon="DayOnesListOpen" /> }

                                {section == 'invites' &&
                                    <TopperTitle
                                        title="Available Tasks"
                                        url="/invites"
                                        icon="Inbox" /> }


                        {section == 'settings' &&
                            <TopperTitle
                                title="Settings"
                                url="/settings"
                                icon="SettingsTwoTone" />
                                }


                        {section == 'collabs' &&
                            <TopperTitle
                                title="Your Collaborations"
                                url="/collabs"
                                icon="AssignmentInd" />
                                }

                        {section == 'assistant' &&
                            <TopperTitle
                                title={sectionKey ? <IdentityAvatar size="name" identityKey={sectionKey} /> : "Assistant"}
                                url={`/identity/${sectionKey}`}
                                icon="AssignmentInd" />
                                }

                        {section == 'support' &&
                            <TopperTitle
                                color="success"
                                title="Support"
                                url="/support"
                                icon="SupportAgent" />
                        }
                        {section == 'requests' &&
                            <TopperTitle
                                title="Requests"
                                url="/support"
                                icon="ListAlt" />
                        }

                        {section == 'lore' &&
                            <TopperTitle
                                title="Lore"
                                tooltip="Fancy Hands Documentation"
                                url="/"
                                icon="AutoStoriesOutlined" />
                        }
                        {section == 'calendar' &&
                            <TopperTitle
                                title="Calendar"
                                tooltip="Your calendar"
                                url="/calendar"
                                loreSlug="feature/business/calendar"
                                icon="DayOnesCalendar" />
                        }
                       {section == 'email' &&
                            <TopperTitle
                                title="Email"
                                tooltip="Your Email"
                                url="/email"
                                loreSlug="feature/business/email"
                                icon="DayOnesEmail" />
                        }
                       {section == 'dedicated' &&
                            <TopperTitle
                                title="Dedicated"
                                tooltip="Dedicated Dashboard"
                                url="/dedicated"
                                icon="DayOnesDedicated" />
                        }
                        {section == 'chat' &&
                            <ChatTopper /> }
                          {section == 'phone' &&
                             <TopperTitle
                                  title="Phone"
                                  tooltip="Your Phone"
                                  url="/phone"
                                  icon="DayOnesPhone" />
                        }
                          {section == 'parcel' &&
                             <TopperTitle
                                  title="Parcel"
                                  tooltip="Your physical mail and package"
                                  url="/parcel"
                                  icon="DayOnesParcel" />
                            }
                       {section == 'team' &&
                            <TopperTitle
                                title="Team Status"
                                tooltip="Your team, right now."
                                url="/team"
                                icon="DayOnesTeam" />
                        }
                        {section == 'roadmap' &&
                            <TopperTitle
                                title="Roadmap"
                                tooltip="Your team's roadmap"
                                url="/roadmap"
                                icon="DayOnesRoadmap" />
                        }

                       {section == 'performance' &&
                            <TopperTitle
                                title="Performance"
                                tooltip="Your team's performance"
                                url="/performance"
                                loreSlug="feature/business/performance"
                                icon="DayOnesPerformance" />
                        }
                        {section == '' &&
                            <TopperTitle
                                color="neutral"
                                title="Home"
                                url="/"
                                icon="CottageTwoTone" />
                        }
                    </Stack>
                    }

                    <Stack
                        width="100%"
                        sx={{ height: "var(--TopperHeight)" }}>
                    {currentIdentity?.role == 'assistant' &&
                        <Stack
                            width="100%"
                            direction="row"
                            alignItems="center"
                            sx={{
                                height: 'var(--ProjectHeaderHeight)',
                                display: 'flex',
                            }}
                        >
                            <ClockHeader />
                        </Stack>}
                    {currentIdentity?.role == 'client' &&
                        <ProjectHeader />}
                    </Stack>

                    <Box sx={{ flexGrow: 1 }}></Box>


                    <Stack
                                                        className="no-print"
                        direction="row"
                        spacing={1}
                        display={{ xs: 'none', sm: 'flex' }}
                    >
                        <UserPresenceIndicator />
                    </Stack>

                </Stack>
            </Stack>
                </Stack>
        </>
    );
});
export default Topper;
